<nz-tabs [(nzSelectedIndex)]="selectedQuoteOptionTabIndex" [nzType]="isReadOnly ? 'line' : 'editable-card'" (nzAdd)="!isReadOnly ? onClickAddOption() : null">
    @for (option of quote.quoteOptions; track $index) {
    <nz-tab [nzTitle]="option.optionNumber + ': ' + option.name">
        @if (quote.quoteOptions.length > 1 && (!isReadOnly || canSelectOptions)) {
            <div style="text-align: right;">
                <button nz-button nzType="primary" nzSize="small" style="border-top-left-radius: 20px; padding-left: 20px;" (click)="selectOption(option)">
                    <nz-icon nzType="check-circle" nzTheme="outline" /> Select Option</button>
                <button nz-button nzType="primary" nzDanger nzSize="small" style="border-top-right-radius: 20px; padding-right: 20px;" (click)="removeOption(option)">
                    <nz-icon nzType="close-circle" nzTheme="outline" /> Remove Option</button>
            </div>
        }
        <nz-table #optionTable [nzData]="option.quoteLines" nzFrontPagination="false" [nzPageSize]="100" [nzLoading]="isLoadingLines">
        <thead>
            <tr>
                <th>Description</th>
                <th>Stock Code</th>
                <th>Qty</th>
                <th>Price (Ex)</th>
                <th>Total (Ex)</th>
                @if (quoteOptionHasCost(option)) {
                    <th>
                        GP
                    </th>
                }
                
                <th></th>
                
            </tr>
        </thead>
        <tbody>
            @for (line of optionTable.data; track $index) {
                <tr>
                    <td>{{line.description}}</td>
                    <td>{{line.stockCode}}</td>
                    <td>
                        <nz-input-number [(ngModel)]="line.qty" [nzMin]="1" [nzDisabled]="isReadOnly" ></nz-input-number>
                    </td>
                    <td>
                        <nz-input-number [(ngModel)]="line.price" [nzMin]="0" [nzDisabled]="isReadOnly"></nz-input-number>
                    </td>
                    <td>R{{(line.qty * line.price) | number:'1.2-2'}}</td>
                    @if (quoteOptionHasCost(option)) {
                        <td>
                            @if (line.cost == null || line.cost === 0) {
                                <small style="color: red;">?</small><br />
                            }
                            <small>R{{ calculateLineItemGP(line).randValue | number:'1.2-2' }}<br />({{ calculateLineItemGP(line).percentage | number:'1.2-2' }}%)</small>
                        </td>
                    }
                    <td>
                        @if (!isReadOnly) {
                            <button nz-button nzType="text" nzDanger (click)="removeLineItem(line, option)">
                                <nz-icon nzType="close-circle" nzTheme="outline" />
                            </button>
                        }
                    </td>
                </tr>
            }
            @if (!isReadOnly) {
                <tr>
                    <td colspan="6">
                        <button nz-button nzType="dashed" nzSize="small" (click)="onClickAddNewItem(option)" ><nz-icon nzType="plus-circle" nzTheme="outline" /> Add Item</button>
                        <button nz-button nzType="dashed" nzSize="small" (click)="onClickAddStockGroups(option)" ><nz-icon nzType="plus-circle" nzTheme="outline" /> Add Group</button>
                    </td>
                </tr>
            }
            <tr>
                <td colspan="4">
                    <b>Option Total:</b>
                </td>
                <td colspan="2">
                    <b>R{{ optionTotal(option) | number:'1.2-2' }} (Ex VAT)</b>
                    @if (quoteOptionHasCost(option)){
                        <br />
                        <small>GP: R{{ calculateQuoteOptionGP(option).randValue | number:'1.2-2' }} ({{ calculateQuoteOptionGP(option).percentage | number:'1.2-2' }}%)</small>
                    }
                </td>
            </tr>
        </tbody>
        </nz-table>
    </nz-tab>
    }
</nz-tabs>




<nz-modal [(nzVisible)]="isShowingAddStockModal" nzTitle="Add Item To Quote" (nzOnCancel)="isShowingAddStockModal = false" (nzOnOk)="isShowingAddStockModal = false"
    [nzFooter]="null" [nzWidth]="'95%'" >
    <ng-container *nzModalContent>
        <nz-tabs>
            <nz-tab nzTitle="Other">
                @if (isLoadingStock) {
                    <ng-container >
                        <nz-skeleton [nzActive]="true" [nzParagraph]="{ rows: 4 }"></nz-skeleton>
                    </ng-container>
                } @else {
                    <ng-container>
                        <nz-table #customStockTable [nzData]="incidentStock.stockCustomItems" [nzPageSize]="15">
                            <thead>
                                <tr>
                                    <th>Code</th>
                                    <th>Description</th>
                                    <th>SOH</th>
                                    <th>Price (Ex)</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (item of customStockTable.data; track $index) {
                                    <tr>
                                        <td>{{item.stockCode}}</td>
                                        <td>{{item.description}}</td>
                                        <td>{{item.soh}}</td>
                                        <td>R{{item.price | number:'1.2-2'}}</td>
                                        <td>
                                            <button nz-button nzType="primary" (click)="onClickStockCustomToBeAdded(item)">Add</button>
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </nz-table>
                    </ng-container>
                }
            </nz-tab>
            <nz-tab nzTitle="Tyres">
                @if (isLoadingStock) {
                    <ng-container>
                        <nz-skeleton [nzActive]="true" [nzParagraph]="{ rows: 4 }"></nz-skeleton>
                    </ng-container>
                } @else {
                    <ng-container>
                        <nz-table #tyreTable [nzData]="incidentStock.stockItems" [nzPageSize]="15">
                            <thead>
                                <tr>
                                    
                                    <th>Brand</th>
                                    <th>Code</th>
                                    <th>Description</th>
                                    <th>SOH</th>
                                    <th>Price (Ex)</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (item of tyreTable.data; track $index) {
                                    <tr>
                                        
                                        <td>{{item.tyreBrand}}</td>
                                        <td>{{item.stockCode}}</td>
                                        <td>{{item.description}}</td>
                                        <td>{{item.soh}}</td>
                                        <td>R{{item.price | number:'1.2-2'}}</td>
                                        <td>
                                            <button nz-button nzType="primary" (click)="onClickTyreToBeAdded(item)"><nz-icon nzType="plus-circle" nzTheme="outline" />Add</button>
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </nz-table>
                    </ng-container>
                }
            </nz-tab>
        </nz-tabs>
    </ng-container>
</nz-modal>

<nz-modal [(nzVisible)]="isShowingStockGroupsModal" nzTitle="Add Stock Group To Quote" (nzOnCancel)="isShowingStockGroupsModal = false" (nzOnOk)="isShowingStockGroupsModal = false"
    [nzFooter]="null" [nzWidth]="'500px'" >
    <ng-container *nzModalContent>
        @if (isLoadingStockGroups) {
            <ng-container>
                <nz-skeleton [nzActive]="true" [nzParagraph]="{ rows: 4 }"></nz-skeleton>
            </ng-container>
        } @else {
            <ng-container>
                <nz-table #stockGroupTable [nzData]="stockGroups" [nzPageSize]="15">
                    <thead>
                        <tr>
                            <th>Group Name</th>
                            
                            <th>Number of Items</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (group of stockGroupTable.data; track $index) {
                            <tr>
                                <td>{{group.stockGroupName}}</td>
                                
                                <td>{{group.stockItems.length}}</td>
                                <td>
                                    <button nz-button nzType="primary" (click)="onClickStockGroupToBeAdded(group)"><nz-icon nzType="plus-circle" nzTheme="outline" />Add</button>
                                </td>
                            </tr>
                        }
                    </tbody>
                </nz-table>
            </ng-container>
        }
    </ng-container>
                        